<div [id]="id" tabindex="-1" class="fixed top-0 left-0 right-0 z-50 hidden w-full p-4 overflow-x-hidden overflow-y-auto md:inset-0 h-full">
    <div class="w-96 max-h-full rounded-lg bg-white">
        @if (!loading) {
            <div class="fixed top-40 primary-purple-light-2-background w-96 pl-6 pr-6 rounded-lg shadow dark:bg-gray-700">
                <div class="flex justify-center">
                    <h3 class="w-full text-base font-bold mb-3 dark:text-gray-400 mt-5">{{ literalService.get(multiple ? 'bookings.actions.reassignBookings.modalTitle' : 'bookings.modal.editField', true) }}</h3>
                    <button (click)="modal.hide()" type="button" class="absolute top-2 right-2 mr-2 text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ml-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
                        <img [src]="images.close" class="h-6 w-6" />
                    </button>
                </div>
                <div class="pt-2 mb-5" [ngClass]="{'neutrals-grey-03-text': confirmChange}">
                    @if (multiple) {
                        <p class="mb-6">{{ text }}</p>
                    }
                    @if (routes) {
                        <app-input  [data]="routes"
                                    [edit]="true"
                                    [independent]="true"
                                    [translateValue]="false"
                                    [hasErrors]="false"
                                    [error]="'showError(routes.value, routes.edit?.valueToChange)'"
                                    (setEventEmitter)="setRoute($event.value)"
                        />
                    }
                    @if (loadingAvailabilities) {
                        <div class="mt-4 flex justify-center py-4">
                            <img [src]="images.loading" alt="loading" class="w-8 h-8 animate-spin" />
                        </div>
                    } @else if (availabilities) {
                        <div class="mt-4"></div>
                        <app-input  [data]="availabilities"
                                    [edit]="true"
                                    [independent]="true"
                                    [translateValue]="false"
                                    [hasErrors]="false"
                                    [error]="'showError(availabilities.value, availabilities.edit?.valueToChange)'"
                                    (setEventEmitter)="set($event.value)"
                        />
                    }
                </div>
                @if (showRecomputePriceToggle) {
                    <div class="flex items-center justify-between mb-2">
                        <div class="flex gap-2 items-center">
                            <img [src]="images.booking.fare" alt="recomputePrice" class="h-6 w-6" />
                            <label class="font-bold">{{ literalService.get('bookings.actions.editBooking.recomputePrice', true) }}</label>
                        </div>
                        <app-toggle [id]="'recomputePrice'" [checked]="recomputePrice" (change)="recomputePrice = !recomputePrice;"></app-toggle>
                    </div>
                }
                <div class="flex items-center justify-between mb-2">
                    <div class="flex gap-2 items-center">
                        <img [src]="images.booking.notifications" alt="notify" class="h-6 w-6" />
                        <label class="font-bold">{{ literalService.get('bookings.actions.deleteBooking.notify', true) }}</label>
                    </div>
                    <app-toggle [id]="'notify'" [checked]="notify" (change)="notify = !notify;"></app-toggle>
                </div>
                @if (confirmChange) {
                    <div class="my-8">
                        <p class="text-base font-bold mb-2">{{ literalService.get('bookings.actions.editBooking.ticketingAlert.title', true) }}</p>
                        <p class="text-base font-normal">{{ literalService.get('bookings.actions.editBooking.ticketingAlert.pre', true) }}<span class="primary-purple-light-text font-semibold">{{ literalService.get('bookings.actions.editBooking.ticketingAlert.highlight', false) }}</span>{{ literalService.get('bookings.actions.editBooking.ticketingAlert.post', false) }}</p>
                    </div>
                }
                <div class="flex items-center justify-between space-x-4 pb-4 w-full gap-2">
                    <button type="button" (click)="onCancel()" class="secondary mt-2 p-2 border-2 w-full font-semibold uppercase cursor-pointer">{{ literalService.get('cancel', true) }}</button>

                    <button type="button"
                        [disabled]="!availabilitySelected"
                        class="primary mt-2 p-2 border-2 w-full font-semibold text-white uppercase cursor-pointer"
                        (click)="onSubmit()">{{ literalService.get(needsConfirmation && confirmChange ? 'confirm' : 'update', true) }}</button>
                </div>
            </div>
        }
        @else {
            <article class="flex w-full justify-center items-center mb-9 pt-8">
                <ng-lottie class="w-24" height="100%" width="100%" [options]="loadingAnimation" (animationCreated)="utilsService.animationCreated($event, 1)" />
            </article>
            <div class="pb-6 flex flex-col w-[75%] mx-auto min-w-1/2">
                <div class="flex justify-between items-center mb-2">
                    <p class="flex justify-start items-center text-lg font-bold">{{ literalService.get('doingAction.title', true) }}</p>
                    <label class="text-[18px] font-semibold primary-purple-light-text">{{ loadingPercentage }}%</label>
                </div>
                <div class="flex justify-center">
                    <progress class="progress primary-purple-light-text" [value]="loadingPercentage" max="100"></progress>
                </div>
            </div>
        }
    </div>
</div>